const funcion10 = {
    titulo: `Función: funciones flecha`,
    problemas: [
      {
        codigo: 1,
        descripcion: `Las funciones flechas son una forma alternativa y concisa para implementar las funciones de expresión clásicas de JavaScript. También podemos implementar funciones flechas que sean anónimas.`,
        programa: `function operar(v1, v2, cb) {
  let resu = cb(v1, v2)
  return resu
}
      
const resultado = operar(5, 10, (v1, v2) => { return v1 + v2 })
console.log(resultado)`,
        solucion: "15"
      }, {
        codigo: 2,
        descripcion: `Inclusive en los casos que haya una sola expresión en la función flecha (es muy común dicha situación) podemos obviar las llaves y la palabra clave return.
Luego el problema anterior en su formato más conciso queda con la sintaxis:`,
        programa: `function operar(v1, v2, cb) {
  let resu = cb(v1, v2)
  return resu
}
      
let resultado = operar(5, 10, (v1, v2) => v1 + v2)
console.log(resultado)`,
        solucion: "15"
      }, {
        codigo: 3,
        descripcion: `La sintaxis de funciones flechas se pueden utilizar no solo en funciones anónimas:`,
        programa: `const sumar = (a, b) => a + b

console.log(sumar(1, 2))`,
        solucion: "3"
      }, {
        codigo: 4,
        descripcion: `Si la función flecha tiene un solo parámetro, podemos omitir los paréntesis del parámetro:`,
        programa: `const elevarCuadrado = x => x ** 2
console.log(elevarCuadrado(5))`,
        solucion: "25"
      }
    ]
  }
  
  export default funcion10;